export const FileSuccessIcon = ({ ...props }) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 8C0 3.58172 3.58172 0 8 0C12.4163 0.00478125 15.9952 3.58369 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8ZM6.99984 11.3333C6.82453 11.3334 6.65092 11.299 6.48894 11.2319C6.32695 11.1649 6.17978 11.0666 6.05584 10.9426L3.53317 8.47661C3.40675 8.35284 3.33468 8.18392 3.3328 8.00701C3.33093 7.8301 3.3994 7.65969 3.52317 7.53327C3.64694 7.40685 3.81586 7.33478 3.99277 7.3329C4.16968 7.33103 4.34009 7.3995 4.46651 7.52327L6.99517 9.99461L11.5325 5.52794C11.6605 5.41536 11.8267 5.35605 11.997 5.36221C12.1673 5.36837 12.3288 5.43953 12.4483 5.56106C12.5678 5.68259 12.6362 5.84527 12.6394 6.01567C12.6427 6.18607 12.5806 6.35125 12.4658 6.47727L7.93717 10.9486C7.8139 11.0712 7.66766 11.1683 7.50682 11.2343C7.34598 11.3003 7.1737 11.3339 6.99984 11.3333Z"
      fill="#658D1B"
    />
  </svg>
);

export const FileErrorIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_339_35155)">
      <path
        d="M8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8C15.9952 3.58369 12.4163 0.00478125 8 0ZM10.6667 9.72466C10.9376 9.974 10.9551 10.3958 10.7057 10.6667C10.4564 10.9376 10.0346 10.9551 9.76372 10.7057C9.75016 10.6933 9.73716 10.6802 9.72466 10.6667L8 8.94266L6.276 10.6667C6.01116 10.9224 5.58913 10.9151 5.33334 10.6503C5.08384 10.3919 5.08384 9.98234 5.33334 9.724L7.05734 8L5.33334 6.276C5.07756 6.01116 5.08491 5.58913 5.34975 5.33334C5.60809 5.08384 6.01766 5.08384 6.276 5.33334L8 7.05734L9.72466 5.33334C9.974 5.06244 10.3958 5.04494 10.6667 5.29428C10.9376 5.54363 10.9551 5.96537 10.7057 6.23628C10.6933 6.24984 10.6802 6.26284 10.6667 6.27534L8.94266 8L10.6667 9.72466Z"
        fill="#BF0002"
      />
    </g>
    <defs>
      <clipPath id="clip0_339_35155">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
